import React from 'react';
import {PhoneFilled, MailFilled, HomeFilled} from '@ant-design/icons';
import Avatar from '../avatar';
import Title from '../text/Title';
import ContactField from './ContactField';
import RightAddress from '../header/RightAddress';

const customStyle = {fontSize: 20, marginRight: 15};

function DrawerContent() {
  return (
    <div>
      <Avatar />
      <p style={{marginBottom: 15, marginTop: 15}}>
        ThelazyStudio Specially Designed For Consulting And Finance Industry.
      </p>
      <Title>Contact Info</Title>
      <ContactField
        line1="(+88) 09999999"
        line2="(+88) 08888888"
        Icon={<PhoneFilled style={customStyle} />}
      />
      <ContactField
        line1="thelazyman193@gmail.com"
        line2="lzstudio@lazy.com"
        Icon={<MailFilled style={customStyle} />}
      />

      <ContactField
        line1="Thanh Xuan District"
        line2="Ha Noi, Viet Nam"
        Icon={<HomeFilled style={customStyle} />}
      />
      <Title>Follow Us</Title>
      <RightAddress />
    </div>
  );
}

export default React.memo(DrawerContent);
